module.exports = __webpack_public_path__ + "resource/img/image035.8bf8f378.png";